import { render } from "./buttonNomalView.vue?vue&type=template&id=2917a969&scoped=true"
import script from "./buttonNomalView.vue?vue&type=script&lang=js"
export * from "./buttonNomalView.vue?vue&type=script&lang=js"

import "./buttonNomalView.vue?vue&type=style&index=0&id=2917a969&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2917a969"]])

export default __exports__